import React from "react";
import clsx from "clsx";
import makeStyles from '@mui/styles/makeStyles';
import Drawer from "@mui/material/Drawer";
import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";
import logo from "../../../assets/images/logo-s.png";
import { useUserState } from "../../../providers/UserProvider";
import * as DataServices from "../../../api/DataServices";

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
});

export default function TemporaryDrawer({
  toggleDrawer,
  anchor,
  drawerStatus,
}) {
  const { t } = useTranslation();
  const classes = useStyles();
  const user = useUserState();
  let userType = user?.user_login?.approve;

  const renderDrawerItems = () => {
    if (user) {
      let menu = [];
      if (userType === "doctor") {
        menu = [
          {
            title: t("components.Layout.drawer.myVisit"),
            link: "/",
            target: false,
          },
          {
            title: t("components.Layout.drawer.homePage"),
            link: DataServices.webConfig("info_site"),
            target: false,
          },
          {
            title: t("components.Layout.drawer.otherSpecialties"),
            link: DataServices.webConfig("info_site") + "specialties",
            target: false,
          },
          {
            title: t("components.Layout.drawer.faq"),
            link: DataServices.webConfig("info_site") + "سوالات-متداول/",
            target: false,
          },
          {
            title: t("components.Layout.drawer.guid"),
            link: DataServices.webConfig("info_site") + "آموزش-کار-با-سامانه/",
            target: false,
          },
          {
            title: t("components.Layout.drawer.onlineSupport"),
            link: DataServices.webConfig("info_site") + "doctors/triage",
            target: false,
          },
        ];
        return menu.map(function (item, index) {
          return (
            <a
              key={Math.random()}
              className="category"
              href={item.link}
              target={item.target}
            >
              <span className="category__name"> {item.title} </span>
            </a>
          );
        });
      } else {
        menu = [
          {
            title: t("components.Layout.drawer.myVisit"),
            link: "/",
            target: false,
          },
          {
            title: t("components.Layout.drawer.homePage"),
            link: DataServices.webConfig("info_site"),
            target: false,
          },
          {
            title: t("components.Layout.drawer.otherSpecialties"),
            link: DataServices.webConfig("info_site") + "specialties",
            target: false,
          },
          {
            title: t("components.Layout.drawer.faq"),
            link: DataServices.webConfig("info_site") + "سوالات-متداول/",
            target: false,
          },
          {
            title: t("components.Layout.drawer.guid"),
            link: DataServices.webConfig("info_site") + "آموزش-کار-با-سامانه/",
            target: false,
          },
          {
            title: t("components.Layout.drawer.healthKnowledge"),
            link: DataServices.webConfig("info_site") + "blog",
            target: false,
          },
          {
            title: t("components.Layout.drawer.triage"),
            link: DataServices.webConfig("info_site") + "doctors/triage",
            target: false,
          },
        ];
        return menu.map(function (item, index) {
          return (
            <a
              key={Math.random()}
              className="category"
              href={item.link}
              target={item.target}
            >
              <span className="category__name"> {item.title} </span>
            </a>
          );
        });
      }
    }
  };

  const renderSocialMediaIcons = () => {
    return (
      <div className={styles.socialMediaIcons}>
        {userType === "doctor" && (
          <>
            <a
              className={styles.linkBorder}
              href={DataServices.webConfig("info_site") + "blog"}
            >
              {t("components.Layout.drawer.medicalKnowledge")}
              
            </a>
            <div className="help_sbm">
              <a href="tel:02191300842">
                <div className={styles.tel}>021-91300842</div>
              </a>
              <p className={styles.textHelp}>
              {t("components.Layout.drawer.needHelp")}

              </p>
            </div>
          </>
        )}
        <ul>
          <li>
            <a
              target="_blank"
              href="https://www.instagram.com/sbm24.official/"
              title="instagram"
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="29"
                height="27"
                viewBox="0 0 29 27"
              >
                <g fill="none" fillRule="evenodd">
                  <rect width="29" height="27" fill="#7747c0" rx="13.5" />
                  <path
                    fill="#fff"
                    fillRule="nonzero"
                    d="M11.023 6C8.253 6 6 8.12 6 10.727v6.546C6 19.88 8.252 22 11.023 22h6.954C20.747 22 23 19.88 23 17.273v-6.546C23 8.12 20.747 6 17.977 6h-6.954zm8.152 3.027c.467 0 .85.292.85.649 0 .356-.383.648-.85.648-.468 0-.85-.292-.85-.648 0-.357.383-.649.85-.649zM14.5 10.324c2.345 0 4.25 1.842 4.25 4.108 0 2.267-1.905 4.109-4.25 4.109-2.345 0-4.25-1.842-4.25-4.109 0-2.266 1.905-4.108 4.25-4.108zm0 .433c-1.874 0-3.4 1.456-3.4 3.243s1.526 3.243 3.4 3.243c1.874 0 3.4-1.456 3.4-3.243s-1.526-3.243-3.4-3.243z"
                  />
                </g>
              </svg>
            </a>
          </li>
          <li>
            <a href="mailto:info@sbm24.com" title="ایمیل">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="29"
                height="27"
                viewBox="0 0 29 27"
              >
                <g fill="none" fillRule="evenodd">
                  <rect width="29" height="27" fill="#7747c0" rx="13.5" />
                  <g fill="#fff" fillRule="nonzero">
                    <path
                      d="M17.725 10.337c.085.077.12.191.094.3-.028.108-.114.194-.226.226s-.234.004-.319-.073L12.12 6.147l-1.502 1.105c-.652.504-1.587.504-2.239 0l-1.5-1.105-.03.034-5.124 4.61c-.084.084-.21.116-.326.085-.116-.031-.205-.12-.23-.233-.027-.113.014-.23.106-.304l5.088-4.575-6.266-4.61C.033 1.32 0 1.496 0 1.674v8.794C0 11.314.72 12 1.608 12H17.39C18.28 12 19 11.314 19 10.468V1.673c0-.177-.033-.353-.097-.52l-6.257 4.608 5.08 4.576z"
                      transform="translate(5 8)"
                    />
                    <path
                      d="M10.344 6.677L18.756.482C18.451.174 18.026 0 17.581 0H1.663C1.218 0 .793.174.487.482l8.408 6.195c.422.328 1.028.328 1.45 0z"
                      transform="translate(5 8)"
                    />
                  </g>
                </g>
              </svg>
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href="https://www.aparat.com/Sbm24"
              title="aparat"
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="29"
                height="27"
                viewBox="0 0 29 27"
              >
                <g fill="none" fillRule="evenodd">
                  <rect width="29" height="27" fill="#7747c0" rx="13.5" />
                  <g fill="#fff" fillRule="nonzero">
                    <path
                      d="M5.658.06c-.152.038-.472.165-.71.278-.584.273-1.167.825-1.436 1.358-.152.293-.482 1.348-.71 2.252-.025.092.163-.064.69-.567 1.045-1.006 2.039-1.646 3.322-2.15.573-.224 1.694-.527 2.181-.59.147-.02.259-.045.244-.054-.01-.01-.487-.142-1.055-.293C7.26.054 7.088.024 6.545.005c-.436-.014-.69 0-.887.054zM9.618 1.46c-1.044.101-2.073.393-3.052.857-2.76 1.32-4.643 3.86-5.094 6.878-.096.645-.096 1.966 0 2.61.451 3.02 2.334 5.56 5.094 6.88 2.937 1.4 6.355 1.148 9.06-.676 2.039-1.37 3.374-3.406 3.876-5.896.13-.65.13-2.575 0-3.225-.502-2.49-1.837-4.525-3.875-5.896-1.772-1.194-3.9-1.733-6.009-1.532zM8.434 3.93c1.41.292 2.329 1.758 1.973 3.144-.502 1.935-2.927 2.595-4.337 1.18-1.014-1.019-1.01-2.576.015-3.604.647-.645 1.48-.902 2.349-.72zm6.63 1.28c1.165.302 1.943 1.29 1.943 2.464 0 .76-.215 1.305-.727 1.819-.352.353-.779.594-1.235.705-.633.146-1.165.08-1.782-.226-1.004-.494-1.581-1.653-1.36-2.727.115-.564.306-.922.712-1.335.527-.53 1.07-.761 1.807-.771.196-.005.487.03.643.07zM10.97 9.562c.381.197.617.565.617.968 0 .872-.843 1.406-1.631 1.033-.296-.136-.387-.232-.522-.534-.442-.973.592-1.955 1.536-1.467zm-3.896 1.215c.151.025.457.14.678.252 1.004.494 1.581 1.653 1.36 2.726-.115.564-.306.922-.712 1.335-.824.832-1.973 1.013-3.027.48-1.35-.686-1.797-2.465-.934-3.725.577-.831 1.616-1.255 2.635-1.068zm6.692 1.29c1.32.343 2.158 1.678 1.882 3.003-.146.69-.743 1.477-1.35 1.769-1.04.504-2.219.317-2.997-.464-1.019-1.018-1.024-2.62-.015-3.633.642-.64 1.601-.902 2.48-.675z"
                      transform="translate(4 3)"
                    />
                    <path
                      d="M16.52 2.56c0 .021.1.115.227.208.573.447 1.454 1.45 1.988 2.277.73 1.118 1.304 2.61 1.51 3.96.035.209.07.37.086.36.01-.016.166-.593.347-1.29C20.96 6.963 21 6.75 21 6.34c0-.92-.327-1.725-.956-2.37-.509-.514-.962-.748-2.04-1.034l-1.142-.312c-.191-.052-.342-.083-.342-.062zM.544 11.952c0 .02-.124.504-.272 1.08C.04 13.933 0 14.141 0 14.534c0 .893.321 1.675.935 2.295.529.53.885.706 2.19 1.06.58.156 1.064.277 1.074.272.01-.01-.045-.07-.124-.131-.277-.217-1.172-1.13-1.469-1.504C1.701 15.392 1 13.89.692 12.461c-.089-.429-.148-.625-.148-.51zM18.255 16.684c-.115.15-.423.484-.684.746-1.42 1.404-3.284 2.401-5.242 2.797-.298.057-.554.118-.564.128-.021.021-.026.021 1.19.34 1.603.421 2.25.411 3.227-.062.72-.35 1.363-1.023 1.624-1.722.136-.345.694-2.386.673-2.448-.01-.025-.11.078-.224.221z"
                      transform="translate(4 3)"
                    />
                  </g>
                </g>
              </svg>
            </a>
          </li>
        </ul>
      </div>
    );
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <div className={styles.mainListContainer}>
        <a href="https://sbm24.com/">
          <div>
            <img src={logo} alt="logo alt" />
          </div>
        </a>
        <div className={styles.menuItems}>{renderDrawerItems()}</div>
        {renderSocialMediaIcons()}
      </div>
    </div>
  );

  return (
    <Drawer
      anchor={anchor}
      open={drawerStatus}
      onClose={toggleDrawer(anchor, false)}
    >
      {list(anchor)}
    </Drawer>
  );
}
